<template lang="pug">
	.easy-creative--generate-answers
		Popup(v-if="visible", :popupVisible.sync="visible",:width="440", :autosize="true", :title="$tCaption('Generate answers')")
			.flex-col.space-large
				.flex-col.space
					.font-big.upper.grey {{$tCaption('Language')}}
					DxSelectBox(:data-source="info.filteredLanguages",  :search-enabled="true", :showClearButton="true", :value="language && language.text", stylingMode="filled", display-expr="text", value-expr="text", @item-click="e => language = e.itemData")
				.flex-col.space
					.font-big.upper.grey {{$tCaption('Instruction')}}
					DxTextArea(:height="120", :value.sync="instruction", stylingMode="filled", value-change-event="input")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="visible = false")
				DxButton(:text="$tCaption('Send')", @click="generateAnswers", type="default")
</template>

<script>
	import Popup from 'app-core/Popup.vue';
	import DxTextArea from 'devextreme-vue/text-area';
	import DxButton from 'devextreme-vue/button';
	import Loader from 'app-core/Loader.vue';
	import cognitiveArrays from 'view/insertion/cognitive-arrays';
	import DxSelectBox from 'devextreme-vue/select-box';

	export default {
		translationCategory: 'creative.EasyCreativeGenerateAnswers',
		name: 'asy-creative--generate-answers',
		props: ['info'],
		mixins: [cognitiveArrays],
		components: {
			Popup, DxTextArea, DxButton, Loader, DxSelectBox
		},
		data() {
			return {
				visible: false,
				text: false,
				loading: false,
				language: null,
				instruction: null
			};
		},
		computed: {
			
		},
		watch: {
			
		},
		mounted() {
			if (__DEBUG__)
				window.easyCreativeGenerateAnswers = this;
		},
		methods: {
			show() {
				this.text = null;
				this.visible = false;
				setImmediate(() => this.visible = true);
			},
			generateAnswers() {
				this.visible = false;
				this.$eventsBus.$emit('easy-creative-generate-answers', { language: this.language?.text, instruction: this.instruction, languageCode: this.language?.locale });
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";
	.easy-creative--generate-answers {

	}
</style>
